import { ApiComponent } from '@ibe/api';

class ExtraComponentListEvent {
  extraComponents: ApiComponent[] | null;
}

export default ExtraComponentListEvent;
